module.exports = __webpack_public_path__ + "static/media/Expo 2020 Dubai_-1.6dd4cc89.jpg";